import React, { useEffect } from "react";
import CountUp from "react-countup";
import { Box, BoxInner } from "../styles";
import ImagIcon from "./ImageIcon";

function Block(props) {
  const { value, display, onClick } = props;

  useEffect(() => {}, [value]);

  return (
    <p onClick={onClick}>
      <Box>
        <BoxInner>
          <ImagIcon display={display} />
          <CountUp
            style={{ color: "white", fontSize: "24px", fontWeight: "500" }}
            suffix={` ${display}`}
            end={value || 0}
            duration={2}
            // redraw
          />
        </BoxInner>
      </Box>
    </p>
  );
}

export default Block;
